module.exports = __webpack_public_path__ + "img/culture_bg_top.b22f95fa.png";